import "./Organigrama.css";

import {
  FaBalanceScale,
  FaBuilding,
  FaBullhorn,
  FaChartLine,
  FaCogs,
  FaCrown,
  FaDraftingCompass,
  FaHandshake,
  FaUserTie,
} from "react-icons/fa";

const directivos = [
  {
    id: 1,
    cargo: "Abogada",
    nombre: "Minerva Portes",
    descripcion:
      "Asesoría legal, revisión contractual y acompañamiento jurídico.",
    icono: <FaBalanceScale />,
  },
  {
    id: 2,
    cargo: "Administradora",
    nombre: "Sarah Yanelis Sánchez Aybar",
    descripcion:
      "Coordinación administrativa, organización interna y seguimiento operativo.",
    icono: <FaUserTie />,
  },
  {
    id: 3,
    cargo: "Director de Marketing",
    nombre: "Sebastián Sánchez Aybar",
    descripcion:
      "Estrategia de marca, comunicación, promoción y presencia digital.",
    icono: <FaBullhorn />,
  },
];

const areasApoyo = [
  {
    id: 1,
    area: "Operaciones",
    descripcion:
      "Coordinación operativa, logística y seguimiento diario de los proyectos.",
    icono: <FaCogs />,
  },
  {
    id: 2,
    area: "Ventas",
    descripcion:
      "Atención comercial, reservas y acompañamiento personalizado al cliente.",
    icono: <FaHandshake />,
  },
  {
    id: 3,
    area: "Ingeniería y Proyectos",
    descripcion:
      "Supervisión técnica, planificación, coordinación de obra y revisión de planos.",
    icono: <FaDraftingCompass />,
  },
  {
    id: 4,
    area: "Finanzas",
    nombre: "Jorge Sanchez Carvajal",
    descripcion:
      "Control financiero, pagos, presupuesto, costos y elaboración de reportes.",
    icono: <FaChartLine />,
  },
];

function Organigrama() {
  return (
    <section className="organigrama" id="organigrama">
      <div className="organigrama-background organigrama-background-left">
        <FaBuilding />
      </div>

      <div className="organigrama-background organigrama-background-right">
        <FaBuilding />
      </div>

      <div className="organigrama-container">
        {/* ENCABEZADO */}

        <header className="organigrama-header">
          <div className="organigrama-eyebrow">
            <span></span>

            <FaBuilding />

            <span></span>
          </div>

          <span className="organigrama-label">
            ESTRUCTURA CORPORATIVA
          </span>

          <h2>Organigrama</h2>

          <p>
            Una estructura profesional, organizada y enfocada en el
            crecimiento continuo de YANNA A&amp;P CONSTRUCTIONS.
          </p>
        </header>

        {/* CEO Y FUNDADORA */}

        <div className="organigrama-ceo-wrapper">
          <article className="organigrama-ceo-card">
            <div className="organigrama-ceo-icon">
              <FaCrown />
            </div>

            <span>CEO Y FUNDADORA</span>

            <div className="organigrama-small-line"></div>

            <h3>Yanneliza Aybar Portes</h3>

            <p>
              Dirección estratégica, liderazgo general y visión de
              crecimiento de la empresa.
            </p>
          </article>

          <div className="organigrama-vertical-line"></div>
        </div>

        {/* DIRECTIVOS */}

        <div className="organigrama-directivos-wrapper">
          <div className="organigrama-directivos-line"></div>

          <div className="organigrama-directivos-grid">
            {directivos.map((directivo) => (
              <article
                className="organigrama-directivo-card"
                key={directivo.id}
              >
                <div className="organigrama-card-connector"></div>

                <div className="organigrama-directivo-icon">
                  {directivo.icono}
                </div>

                <span className="organigrama-cargo">
                  {directivo.cargo}
                </span>

                <div className="organigrama-small-line"></div>

                <h3>{directivo.nombre}</h3>

                <p>{directivo.descripcion}</p>
              </article>
            ))}
          </div>
        </div>

        {/* CONECTOR DE ÁREAS */}

        <div className="organigrama-support-connector">
          <div className="organigrama-support-vertical"></div>
          <div className="organigrama-support-horizontal"></div>
        </div>

        {/* ÁREAS DE APOYO */}

        <div className="organigrama-areas">
          <div className="organigrama-areas-title">
            <span>ÁREAS DE APOYO Y DESARROLLO</span>

            <p>
              Departamentos que respaldan la gestión y ejecución de
              cada proyecto.
            </p>
          </div>

          <div className="organigrama-areas-grid">
            {areasApoyo.map((area) => (
              <article
                className="organigrama-area-card"
                key={area.id}
              >
                <div className="organigrama-area-connector"></div>

                <div className="organigrama-area-icon">
                  {area.icono}
                </div>

                <h3>{area.area}</h3>

            {area.nombre && (
              <span className="organigrama-area-name">
                {area.nombre}
             </span>
            )}


                <div className="organigrama-small-line"></div>

                <p>{area.descripcion}</p>
              </article>
            ))}
          </div>
        </div>

        {/* MENSAJE FINAL */}

        <footer className="organigrama-footer">
          <span></span>

          <FaBuilding />

          <p>
            Una estructura flexible que evoluciona junto al crecimiento
            y las necesidades de la empresa.
          </p>

          <span></span>
        </footer>
      </div>
    </section>
  );
}

export default Organigrama;